/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");
import { apiGlobalResetPwd } from '@/api/global';
export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const formRef = ref();
    const form = ref({
      uid: '',
      suid: '',
      pwd: '',
      type: 0,
      hgGid: 0
    });
    const gid = ref();
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          confirmLoading.value = true;
          apiGlobalResetPwd({
            gid: gid.value,
            ...form.value
          }).then(res => {
            if (res.code === 0) {
              emits('success');
              handleClose();
            }
          }).finally(() => {
            confirmLoading.value = false;
          });
        }
      });
    };
    const show = payload => {
      dialogVisible.value = true;
      form.value = {
        ...payload.data
      };
      gid.value = payload.gid;
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_dialog = __unplugin_components_4;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => dialogVisible.value = $event),
        title: "重置密码",
        width: "600px",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => handleClose())
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: confirmLoading.value,
          type: "primary",
          onClick: _cache[3] || (_cache[3] = $event => handleOk(formRef.value))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          ref_key: "formRef",
          ref: formRef,
          "label-col": {
            span: 4
          },
          "wrapper-col": {
            span: 15
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "账号类型"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(form.value.uid ? '主账号' : '游客'), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "账号ID"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              disabled: "",
              modelValue: form.value.suid,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.suid = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "密码",
            prop: "pwd",
            rules: {
              required: true,
              message: '请输入密码',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.pwd,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.pwd = $event),
              placeholder: "请输入密码"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});